import React, { useEffect,useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

import { accountService, alertService } from '../../_services';

function AddEdit({ history, match }) {
  const { id } = match.params;
  const isAddMode = !id;
  const [init, setInit] = useState({
    venue: '',
    startDate: '',
    lockerType: '',
    isEnded: '',
    isPaid: '',
    isRedeemed: '',
    orderNumber: '',
    accountEmail: '',
    lockerDescription: '',
    lockerGuiAdmin: ''
  });

    useEffect(() => {
        async function fetchData() {
            const init = await accountService.getReservationById(id);
            console.log(init);
            setInit(init);
        }
        fetchData();
    }, []);

    const validationSchema = Yup.object().shape({

    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        if (isAddMode) {
            createReservation(fields, setSubmitting);
        } else {
            updateReservation(id, fields, setSubmitting);
        }
    }

    function createReservation(fields, setSubmitting) {
        accountService.createReservation(fields)
            .then(() => {
                alertService.success('Reservation added successfully', { keepAfterRouteChange: true });
                history.push('.');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    function updateReservation(id, fields, setSubmitting) {
        accountService.updateReservation(id, fields)
            .then(() => {
                alertService.success('Update Reservation successful', { keepAfterRouteChange: true });
                history.push('..');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    return (
        <>
            <div className="card-header header-admin admin-btm-bdr">
                <h2 className="bold-tx">Account</h2>
                    <br />
                    <h4>{init.accountEmail}</h4> 
            </div>

            <p className="rent-agree-marg">
                <strong>Locker Number</strong><br />{init.lockerGuiAdmin}
                <br /><br />
                <strong>Size</strong><br />{init.lockerType}
                <br /><br />
                <strong >Area</strong><br />{init.venue}
                <br /><br />
                <strong >Location</strong><br />{init.lockerDescription}
                <br /><br />
                <strong >Order  Number</strong><br />{init.orderNumber}
                <br /><br />
                <strong >Date</strong><br />{init.startDate}
                <br />
            </p>

            <div className="card-header admin-top-bdrline">
                <Link className="btn btn-link" to={`/admin/reservations`} >Back</Link>
            <br />
        </div>
        </>

    );

  { 
    /*
    <Formik enableReinitialize={true} initialValues={init} validationSchema={validationSchema} onSubmit={onSubmit} values={init}>
      {({ errors, touched, isSubmitting, setFieldValue }) => {
  
        return (
        

          <Form>
            <h1>{isAddMode ? 'Add Reservation' : 'Edit Reservation'}</h1>

            {/*
             * 
             *              *
             * TODO FIXME - size and area selects imply "upgrade" and "reassign" work.
             * make them all work.
             *
             * 
            <div className="form-row">

              <div className="form-group col-6">
                <label>Select Date:</label>
                <Field name="startDate" type="date" className={'form-control' + (errors.startDate && touched.startDate ? ' is-invalid' : '')} />
                <ErrorMessage name="startDate" component="div" className="invalid-feedback" />
              </div>

            </div>
            <Field name="Area" type="hidden" value={init.venue} />
            
            

            <div className="form-row">

              <div className="form-group col-6">
                <label>Select Size:</label>
                <Field as="select" name="lockerType" className={'form-control' + (errors.lockerType && touched.lockerType ? ' is-invalid' : '')} >
                  <option value="Standard">Standard</option>
                  <option value="Large">Large</option>
                  <option value="X-Large">X-Large</option>
                </Field>
                <ErrorMessage name="lockerType" component="div" className="invalid-feedback" />
              </div>

            </div>
           

            <div className="form-row">
              <div className="form-group">

                <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                  {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                  Update Reservation
                              </button>
                <Link to="login" className="btn btn-link">Cancel</Link>
              </div>
            </div>

          </Form>
        );
      }}
      </Formik >
      
      
  );
  */}
}

export { AddEdit };